export default __webpack_public_path__ + "static/media/sign up.ed8af243.svg";